import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StationDetails} from '../../entities/city';

declare var _apiUrl: any ;

@Component({
  selector: 'app-stations-details',
  templateUrl: './stations-details.component.html',
  styleUrls: ['./stations-details.component.css']
})
export class StationsDetailsComponent implements OnInit  {

  @Input() stationId: number;
  @ViewChild('mapIframe') ifrm: ElementRef;
  details: StationDetails = new StationDetails();
  isMapLoad = false;
  constructor(private  http: HttpClient) { }

  ngOnInit() {
    this.http.get<StationDetails>(_apiUrl + '/Gov/GetStationsDetails?stationId=' + this.stationId)
      .subscribe(d => this.SetDEtails(d) );

  }

  private SetDEtails(d: StationDetails) {
    this.details = d;
    this.ifrm.nativeElement.src = "https://new.govmap.gov.il/map.html?c=" + this.details.X + "," +this.details.Y +"&z=10&b=0&lay=POLICE_YEHIDA_LOCATION&mapMode=1";
  }

  public getFrameUrl(): string {
 console.log(234);
    return "https://new.govmap.gov.il/map.html?c=" + this.details.X + "," +this.details.Y +"&z=10&b=0&lay=POLICE_YEHIDA_LOCATION&mapMode=1";
}
public loadMap() {
  this.isMapLoad = ! this.isMapLoad;
}

}
